module.exports = __webpack_public_path__ + "img/study1.773a428f.png";